"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Breadcrumb = _interopRequireDefault(require("../Breadcrumb"));
var __jsx = _react.default.createElement;
var tagBasedBreadcrumbEditConfig = {
  emptyLabel: 'Breadcrumbs - Tag-based',
  isEmpty: function isEmpty(props) {
    if (typeof props.items !== 'undefined' && props.items.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var TagBasedBreadcrumb = function TagBasedBreadcrumb(_ref) {
  var items = _ref.items;
  return __jsx(_Breadcrumb.default, {
    items: items
  });
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/tagbasedbreadcrumb')(TagBasedBreadcrumb, tagBasedBreadcrumbEditConfig);
exports.default = _default;